import React from "react";
import PropTypes from "prop-types";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { graphql, useStaticQuery } from "gatsby";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

function SEO({
  location,
  description,
  lang = "en-us",
  meta,
  keywords,
  title,
  image,
  type = "website",
  article,
}) {
  const data = useStaticQuery(detailsQuery) || {};
  const { sanitySiteSettings, site } = data;
  const metaDescription = description || sanitySiteSettings?.description || "";
  let siteTitle = sanitySiteSettings?.title || "";
  if (title) {
    siteTitle = `${title} | ${site.siteMetadata.title}`;
  }
  const siteAuthor = site.siteMetadata.title;
  let metaImage = image?.asset
    ? imageUrlFor(buildImageObj(image)).width(1200).url()
    : null;
  if (!metaImage) {
    metaImage = sanitySiteSettings?.image?.asset
      ? imageUrlFor(buildImageObj(sanitySiteSettings.image)).width(1200).url()
      : null;
  }
  let metaKeywords = sanitySiteSettings?.keywords || [];
  metaKeywords = [...metaKeywords, ...keywords];

  return (
    <>
      <GatsbySeo
        title={siteTitle}
        description={metaDescription}
        canonical="https://cloudalgo.com"
        language={lang}
        openGraph={{
          type,
          url: `${site.siteMetadata.siteUrl}${location?.pathname || ""}`,
          title: siteTitle,
          description: metaDescription,
          article,
          images: [
            {
              url: metaImage,
              width: 800,
              height: 600,
            },
            {
              url: metaImage,
              width: 900,
              height: 800,
            },
          ],
          site_name: "Cloudalgo",
        }}
        twitter={{
          handle: "@sandeepkhoj",
          site: "@cloudalgo",
          cardType: "summary",
        }}
        metaTags={[
          {
            property: "theme-color",
            content: "#121212",
          },
          {
            property: "keywords",
            content:
              metaKeywords && metaKeywords.length > 0
                ? metaKeywords.join(", ")
                : "",
          },
        ]}
      />
      {/* <Helmet
        htmlAttributes={{ lang }}
        title={siteTitle}
        meta={[
          {
            name: "description",
            content: metaDescription,
          },
          {
            name: "theme-color",
            content: "#121212",
          },
          {
            property: "og:title",
            content: title || sanitySiteSettings?.title || "",
          },
          {
            property: "og:description",
            content: metaDescription,
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            property: "og:image",
            content: metaImage,
          },
          {
            property: "og:url",
            content: `${site.siteMetadata.siteUrl}${location?.pathname || ""}`,
          },
          {
            property: "og:url:secure_url",
            content: `${site.siteMetadata.siteUrl}${location?.pathname || ""}`,
          },
          {
            name: "twitter:card",
            content: "summary",
          },
          {
            name: "twitter:creator",
            content: siteAuthor,
          },
          {
            name: "twitter:title",
            content: title || sanitySiteSettings?.title || "",
          },
          {
            name: "twitter:description",
            content: metaDescription,
          },
          {
            name: "twitter:image",
            content: metaImage,
          },
        ]
          .concat(
            metaKeywords && metaKeywords.length > 0
              ? {
                  name: "keywords",
                  content: metaKeywords.join(", "),
                }
              : [],
          )
          .concat(meta)}
      ></Helmet> */}
    </>
  );
}

SEO.defaultProps = {
  lang: "en",
  meta: [],
  keywords: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    sanitySiteSettings(_id: { eq: "siteSettings" }) {
      title
      description
      keywords
      image {
        ...SanityImage
        alt
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
  }
`;
